import { action, makeAutoObservable } from "mobx";
import INTOUCH_API from "../services/Api";
import isPayplusDomain from "../utils/isPayplusDomain";

// Цены тянем с бэка (GET purchase/prices — серверный справочник, ТЗ #4);
// env REACT_APP_PRICE_* остаются фолбэком для GAME, пока справочник не загружен.
class Pricing {
  prices = null;
  isLoading = false;

  constructor() {
    makeAutoObservable(this);
  }

  async fetch() {
    if (this.prices || this.isLoading) return;
    this.isLoading = true;
    await INTOUCH_API.requestManager(
      "purchase_prices",
      {},
      action((response) => {
        this.prices = response.data;
      }),
      () => {},
      action(() => {
        this.isLoading = false;
      })
    );
  }

  // -> { usd, rub, points } | null
  get(type) {
    if (this.prices && this.prices[type]) return this.prices[type];
    // фолбэк на случай недоступности справочника — зеркало серверного
    // priceCatalog.js: после того как кнопки стали «голой ценой» (без слова
    // «Купить»), пустой format() оставил бы кнопку вовсе без текста
    const FALLBACK = {
      GAME: { usd: 49, rub: 4900, points: 4900 },
      DEMO_GAME: { usd: 49, rub: 4900, points: 4900 },
      REPEAT_TEST: { usd: 9, rub: 900, points: 900 },
      BLANK_FORM: { usd: 5, rub: 500, points: 500 },
      EXTENDED_57: { usd: 19, rub: 1900, points: 1900 },
    };
    return FALLBACK[type] || null;
  }

  // Денежная цена строкой по домену: .ru -> ₽, остальные -> $
  format(type) {
    const price = this.get(type);
    if (!price) return "";
    return isPayplusDomain() ? `${price.usd}$` : `${price.rub} ₽`;
  }
}

export default new Pricing();
